import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

function ProductSearch({
  productNumber,
  setProductNumber,
  products,
  onProductSelect,
  focusProductNumber,
}) {
  const [setLastProduct] = useState();
  const productNumberField = useRef();

  useEffect(() => {
    if (productNumberField.current && focusProductNumber) {
      productNumberField.current.focus();
    }
  }, [productNumberField]);

  return (
    <section>
      <section className="section">
        <div className="container">
          <div
            className="bd-b-gray"
            style={{
              padding: '20px 10px',
              borderBottom: '1px solid #424242'
            }}
          >
            {/* <div style={{ fontSize: 12, color: '#A6A6A6' }}>Search Product #</div> */}
            <input
              ref={productNumberField}
              type="text"
              className="form-control search-input-focus black-bg"
              value={productNumber}
              onChange={({ target: { value } }) => setProductNumber(value)}
              placeholder="Search for a Product"
            />
          </div>

          <div className="row">
            <div className="col-12">
              <ul className="select-list list-unstyled cursor-pointer" style={{ padding: '20px 10px' }}>
                {
                  typeof products !== 'undefined' && products.length === 0 && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    >
                      No results found.
                    </div>
                  )
                }

                {
                  typeof products !== 'undefined' && products.length > 0 && products.map((product, index) => (
                    <Link
                      key={index}
                      onClick={() => onProductSelect(product)}
                    >
                      {
                        index + 1 === products.length
                          ? (
                            <li ref={setLastProduct}>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', minWidth: '100%' }}>
                                  <div>{product.number}</div>
                                  <div>{product.description}</div>
                                </div>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', minWidth: '100%' }}>
                                  <div>{product.number}</div>
                                  <div>{product.description}</div>
                                </div>
                              </div>
                            </li>
                          )
                      }

                    </Link>
                  ))
                }
              </ul>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}

ProductSearch.defaultProps = {
  focusProductNumber: false,
};

ProductSearch.propTypes = {
  productNumber: PropTypes.string.isRequired,
  setProductNumber: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({
    number: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })).isRequired,
  onProductSelect: PropTypes.func.isRequired,
  focusProductNumber: PropTypes.bool,
};

export default ProductSearch;
